module.exports = __webpack_public_path__ + "static/media/email-icon.8db950c7.svg";